import { useEffect, useRef, useState } from 'react'
import { IAccordionProps } from './Accordion.types'

const ANIMATION_TIME = 600

export const Accordion = ({
  children,
  expanded,
  title,
  childrenStyle,
  onToggle,
  ...passingProps
}: IAccordionProps) => {
  const content = useRef<HTMLDivElement>(null)
  const timeout = useRef<NodeJS.Timeout | null>(null)

  const [height, setHeight] = useState<string | undefined>(undefined)

  useEffect(() => {
    // for animation to happen we
    if (!expanded && height === 'unset') {
      setHeight(`${content.current?.scrollHeight}px`)

      timeout.current = setTimeout(() => {
        setHeight(expanded ? 'unset' : '0px')
      }, 100)
    } else {
      setHeight(expanded ? `${content.current?.scrollHeight}px` : '0px')

      timeout.current = setTimeout(() => {
        setHeight(expanded ? 'unset' : '0px')
      }, ANIMATION_TIME)
    }

    return () => {
      clearTimeout(timeout.current as NodeJS.Timeout)
    }
  }, [expanded, children])

  const toggleAccordion = () => {
    onToggle(!expanded)
  }

  return (
    <div style={{ overflow: 'hidden' }} {...passingProps}>
      <div onClick={toggleAccordion}>{title}</div>
      <div
        ref={content}
        style={{
          maxHeight: height,
          backgroundColor: 'white',
          overflow: 'hidden',
          transition: `max-height ${ANIMATION_TIME / 1000}s ease`,
          ...childrenStyle,
        }}
      >
        {children}
      </div>
    </div>
  )
}
